import {
  ARTICLE_TYPE,
  EXTERNAL_TYPE,
  FOLDER_TYPE,
  IFRAME_TYPE,
} from 'hb-react/shared/utils/files/fileContentTypes';

const sharedTypes = {
  [IFRAME_TYPE]: 'Item',
  [EXTERNAL_TYPE]: 'Item',
  [FOLDER_TYPE]: 'Folder',
  [ARTICLE_TYPE]: 'Article',
};

// the type "File" is the one with the most variations and formats
const defaultType = 'File';

/**
 * Get the shared content type, to be use with product analytics
 *
 * @param {string} type
 * @return {string} the file share type for Amplitude
 */
export const getSharedContentType = (type) =>
  `${sharedTypes[type] || defaultType}Shared`;
